import { Theme, Typography } from '@mui/material';
import { FC } from 'react';
import ReactVirtualizedAutoSizer from 'react-virtualized-auto-sizer';
import { makeStyles } from 'tss-react/mui';
import { useSnapshot } from 'valtio';
import { useIsScanning } from '../../new-scan/actions/scan-actions';
import ChartPanelLayout from '../components/ChartPanelLayout';
import FunnelChart from '../components/funnel-chart/FunnelChart';
import FunnelChartLoader from '../components/funnel-chart/FunnelChartLoader';
import IssuePrioritizationStore from '../stores/issue-prioritization-store';

const FunnelChartContainer: FC = () => {
  const { classes } = useStyles();
  const isScanning = useIsScanning();
  const { rawData, startValueSum, endValueSum, loading } = useSnapshot(
    IssuePrioritizationStore,
  );
  const noResults = rawData.length === 0;

  return (
    <ChartPanelLayout
      header={
        <Typography color='text.secondary' variant='body2' fontWeight={600}>
          Issues Prioritizations
        </Typography>
      }>
      <FunnelChartLoader
        isScanning={isScanning}
        loading={loading}
        noResults={noResults}>
        <div className={classes.funnelChartContainer}>
          <div style={{ flexGrow: 1 }}>
            <ReactVirtualizedAutoSizer>
              {({ width, height }) => (
                <FunnelChart data={rawData} width={width} height={height} />
              )}
            </ReactVirtualizedAutoSizer>
          </div>
          <div className={classes.footer}>
            {startValueSum && (
              <Typography
                color='text.secondary'
                variant='body2'
                fontWeight={600}>
                {startValueSum.toLocaleString()}
              </Typography>
            )}
            {endValueSum && (
              <Typography
                color='text.secondary'
                variant='body2'
                fontWeight={600}>
                {endValueSum.toLocaleString()}
              </Typography>
            )}
          </div>
        </div>
      </FunnelChartLoader>
    </ChartPanelLayout>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  funnelChartContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  footer: {
    flex: '0 0 28px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingInline: theme.spacing(1),
    paddingBlockStart: 6,
  },
}));

export default FunnelChartContainer;
